import moment from "moment";

export function strToMins(t) {
  const hours = parseInt(t.slice(0, 2), 10);
  const minutes = parseInt(t.slice(3, 5), 10);
  return hours * 60 + minutes;
}

export function minsToStr(t) {
  const hours = Math.trunc(t / 60);
  // TH1: 0 < hours < 10
  // TH2: 10 < hours < 24
  if (hours > 0 && hours < 10) {
    return "0" + hours + ":" + ("00" + (t % 60)).slice(-2) + ":00";
  } else {
    return hours + ":" + ("00" + (t % 60)).slice(-2) + ":00";
  }
}

export function numberToTime(t) {
  const n = new Date(0, 0);
  n.setSeconds(+t * 60 * 60);
  return n.toISOString().slice(11, 19);
}

export function getHmmss(time) {
  if (time.length === 8) return;
  if (!time) return;
  return time.toTimeString().slice(0, 8);
}

export const convertTimeToDateTime = (timeStr) => {
  if (!timeStr) return;
  if (moment.isDate(timeStr)) return timeStr;
  if (typeof timeStr === "number") return;

  return moment(timeStr, "HH:mm:ss").toDate();
};
export function calculateRestDurationInMinutes(reqTimeIn, reqTimeOut, reqRestTimeIn, reqRestTimeOut) {
  const timeIn = moment(reqTimeIn).format("YYYY-MM-DD HH:mm:ss");
  const timeOut = moment(reqTimeOut).format("YYYY-MM-DD HH:mm:ss");
  let restTimeIn = moment(reqRestTimeIn).format("YYYY-MM-DD HH:mm:ss");
  let restTimeOut = moment(reqRestTimeOut).format("YYYY-MM-DD HH:mm:ss");

  if (moment(timeIn).isAfter(restTimeIn)) {
    restTimeIn = moment(restTimeIn).add(1, "days").format("YYYY-MM-DD HH:mm:ss");
    restTimeOut = moment(restTimeOut).add(1, "days").format("YYYY-MM-DD HH:mm:ss");
  }

  const timeInMoment = moment(timeIn, "YYYY-MM-DD HH:mm:ss");
  const timeOutMoment = moment(timeOut, "YYYY-MM-DD HH:mm:ss");
  const restTimeInMoment = moment(restTimeIn, "YYYY-MM-DD HH:mm:ss");
  const restTimeOutMoment = moment(restTimeOut, "YYYY-MM-DD HH:mm:ss");

  const overlapStart = moment.max(timeInMoment, restTimeInMoment);
  const overlapEnd = moment.min(timeOutMoment, restTimeOutMoment);

  const durationInMinutes = overlapEnd.diff(overlapStart, "hours", true);

  return durationInMinutes;
}


export const isValidRestTime = (
  reqTimeIn,
  reqTimeOut,
  reqRestTimeIn,
  reqRestTimeOut
) => {
  const timeIn = moment(reqTimeIn).format("YYYY-MM-DD HH:mm:ss");
  const timeOut = moment(reqTimeOut).format("YYYY-MM-DD HH:mm:ss");
  let restTimeIn = moment(reqRestTimeIn).format("YYYY-MM-DD HH:mm:ss");
  let restTimeOut = moment(reqRestTimeOut).format("YYYY-MM-DD HH:mm:ss");

  if (moment(timeIn).isAfter(restTimeIn)) {
    restTimeIn = moment(restTimeIn)
      .add(1, "days")
      .format("YYYY-MM-DD HH:mm:ss");
    restTimeOut = moment(restTimeOut)
      .add(1, "days")
      .format("YYYY-MM-DD HH:mm:ss");
  }

  if (
    (timeIn < restTimeIn && timeOut <= restTimeIn) ||
    (timeIn >= restTimeOut && timeOut > restTimeOut)
  ) {
    return false;
  }
  return true;
};

export const IsBeforeShiftFunc = (
  reqTimeIn,
  reqTimeOut,
  reqShiftTimeIn,
  reqShiftTimeOut
) => {
  const startTime = new Date(reqTimeOut);
  startTime.setHours(0, 0, 0, 0);
  const endTime = new Date(reqTimeOut);
  endTime.setHours(12, 0, 0, 0);

  if (moment(reqShiftTimeOut).isBefore(reqShiftTimeIn)) {
    const isAfterEndTime = moment(reqTimeOut).isSameOrAfter(endTime);
    if (isAfterEndTime && moment(reqTimeOut).isSameOrAfter(startTime)) {
      reqTimeOut = moment(reqTimeOut).add(1, "days");
    }

    const isBeforeStartTime = moment(reqTimeIn).isSameOrAfter(startTime);
    if (isBeforeStartTime && moment(reqTimeIn).isBefore(endTime)) {
      reqTimeIn = moment(reqTimeIn).add(1, "days");
    }

    reqShiftTimeOut = moment(reqShiftTimeOut).add(1, "days");
  }

  const isBeforeShift = moment(reqTimeIn).isBefore(reqShiftTimeIn);

  return isBeforeShift;
};
